import React from 'react';

const ApiKeyPermissionGroupCredentialsFormModal = React.lazy(() => import('../components/FormModal'));

const apiKeyPermissionGroupCredentialsModalRegistry = {
    core_apiKeyPermissionGroupCredentialsId: ApiKeyPermissionGroupCredentialsFormModal
};

export default apiKeyPermissionGroupCredentialsModalRegistry;
